import { useState } from 'react';

export const useBsMemo = () => {
  const [memo] = useState(sessionStorage.getItem('SSO_MEMO') !== 'false');

  return memo;
};
